module.exports = "https://statics.teams.cdn.live.net/hashedassets-launcher/v2/welcome_to_teams.54ab72ff735714dfa2420d8a35c98041.svg";